import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ActiveInactiveActivity,
  ActivityImageUpload,
  createActivity,
  deleteActivity,
  getAllActiveActivity,
  getAllActivity,
  getActivityByURL,
  updateActivity,
} from "./activity.services";
import { IActivity, IActivityInitialState } from "./activityModal";

const initialState: IActivityInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  ActivityID: null,
  ActivityList: [],
  ActivityDetail: {
    ID: null,
    ActivityName: "",
    ActivityURL: "",
    Duration: "",
    DifficultyType: "",
    Availability: "",
    IsShowOnHome: false,
    Description: "",
    ShortDescription: "",
    MainImage: "",
    BannerImage: "",
    ActivityBannerImage: "",
    WhatsInclude: "",
    ImportantTips: "",
    MetaTitle: "",
    MetaDescription: "",
    MetaKeywords: "",
    ActivityTimeline: [{ Title: "", Time: "", Description: "", Image: "" }],
    IsActive: 1,
  },
};

const activitySlice = createSlice({
  name: "activity",
  initialState,
  reducers: {
    clearActivityDetails: (state) => {
      state.ActivityDetail = initialState.ActivityDetail;
    },
    setActivityID: (state, action) => {
      state.ActivityID = action.payload;
    },
    clearActivityID: (state) => {
      state.ActivityID = initialState.ActivityID;
    },
  },
  extraReducers: (builder) => {
    const handlers = [
      {
        thunk: getAllActivity,
        listField: "ActivityList" as keyof IActivityInitialState,
      },
      {
        thunk: getAllActiveActivity,
        listField: "ActivityList" as keyof IActivityInitialState,
      },
    ];
    handlers.forEach(({ thunk, listField }) => {
      builder.addCase(thunk.pending, (state) => {
        state.loading = true;
        state.error = "";
      });
      builder.addCase(
        thunk.fulfilled,
        (state, action: PayloadAction<IActivity[]>) => {
          state.loading = false;
          (state[listField] as IActivity[]) = action.payload || [];
        },
      );
      builder.addCase(thunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
        (state[listField] as IActivity[]) = [];
      });
    });
    [
      createActivity,
      updateActivity,
      deleteActivity,
      ActiveInactiveActivity,
      ActivityImageUpload,
    ].forEach((thunk) => {
      builder.addCase(thunk.pending, (state) => {
        state.loading = true;
        state.error = "";
      });
      builder.addCase(thunk.fulfilled, (state) => {
        state.loading = false;
      });
      builder.addCase(thunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      });
    });
    builder.addCase(getActivityByURL.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getActivityByURL.fulfilled, (state, action: any) => {
      state.loading = false;
      state.ActivityDetail = action.payload;
    });
    builder.addCase(getActivityByURL.rejected, (state, action) => {
      state.loading = false;
      state.ActivityDetail = initialState.ActivityDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearActivityDetails, clearActivityID, setActivityID } =
  activitySlice.actions;
export default activitySlice.reducer;
